/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const TAG_VIEWBOX = 18;

const TAG_PATH =
  'M5.62501 4.5C5.40251 4.5 5.185 4.56598 5 4.68959C4.81499 4.81321 4.6708 4.98891 4.58565 5.19448C4.5005 5.40005 4.47822 5.62625 4.52163 5.84447C4.56504 6.0627 4.67218 6.26316 4.82952 6.42049C4.98685 6.57783 5.18731 6.68497 5.40554 6.72838C5.62376 6.77179 5.84996 6.74951 6.05553 6.66436C6.2611 6.57921 6.4368 6.43502 6.56042 6.25001C6.68403 6.06501 6.75001 5.8475 6.75001 5.625C6.75001 5.32663 6.63149 5.04048 6.42051 4.8295C6.20953 4.61852 5.92338 4.5 5.62501 4.5V4.5ZM15.84 8.0325L9.53251 1.7175C9.46243 1.64799 9.37932 1.59299 9.28794 1.55567C9.19656 1.51835 9.09872 1.49943 9.00001 1.5H2.25001C2.0511 1.5 1.86033 1.57901 1.71968 1.71967C1.57903 1.86032 1.50001 2.05108 1.50001 2.25V9C1.49944 9.0987 1.51836 9.19655 1.55568 9.28793C1.59301 9.37931 1.648 9.46242 1.71751 9.5325L8.03251 15.84C8.45439 16.2613 9.02626 16.498 9.62251 16.498C10.2188 16.498 10.7906 16.2613 11.2125 15.84L15.84 11.25C16.2614 10.8281 16.498 10.2562 16.498 9.66C16.498 9.06375 16.2614 8.49187 15.84 8.07V8.0325ZM14.7825 10.1475L10.1475 14.775C10.007 14.9147 9.8169 14.9931 9.61876 14.9931C9.42062 14.9931 9.23053 14.9147 9.09001 14.775L3.00001 8.6925V3H8.69251L14.7825 9.09C14.852 9.16008 14.907 9.24319 14.9443 9.33457C14.9817 9.42595 15.0006 9.52379 15 9.6225C14.9992 9.81925 14.9211 10.0078 14.7825 10.1475V10.1475Z';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Price tag (18×18). Color via `fill` or CSS `color` + `currentColor`. */
const TagIcon = ({
  size = 18,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${TAG_VIEWBOX} ${TAG_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={TAG_PATH} fill={fill} />
  </svg>
);

TagIcon.propTypes = iconPropTypes;

export { TagIcon };
export default TagIcon;
